<template>
    <v-dialog v-model="showDialog" max-width="600px" persistent>
        <v-sheet class="dialog" rounded>
            <div class="dialog-header">{{ $t("drivers.secret_code") }}</div>
            <div class="dialog-content">
                <p v-if="driver">{{
                        $t('drivers.message',
                            [
                                driver.firstname,
                                driver.lastname,
                                driver.login,
                            ]
                        )
                    }}</p>
                <h3 v-if="driver" class="h3">{{ driver.code }}</h3>
            </div>
            <div class="dialog-footer d-flex">
                <v-spacer></v-spacer>
                <v-btn color="warning" elevation="0"
                       @click="showDialog = false">
                    {{ $t("global.i_understand") }}
                </v-btn
                >
            </div>
        </v-sheet>
    </v-dialog>
</template>

<script>
export default {
    name: "SecretCode",
    props: {
        visible: {
            type: Boolean,
            required: true,
            default: false,
        },
        driver: {
            required: false,
            type: Object,
            default: () => null
        }
    },
    computed: {
        showDialog: {
            get() {
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },
}
</script>

<style scoped>

</style>
